import { Box } from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";
import { type ReactNode } from "react";

import { useIsMobile } from "../../../AppLayout/useResponsive";
import { BottomSheet } from "../../../components/BottomSheet";
import { DialogHeader } from "../../../components/DialogHeader";
import { Drawer } from "../../../components/Drawer";

interface RequestIncreaseDrawerProps {
  modalState: UseModalState;
  title: string;
  children: ReactNode;
}

/**
 * Non-dialog presentation for the spending-limit increase request. Matches the admin
 * `SpendingControlDialog`: a bottom sheet on mobile, a right-anchored drawer on desktop.
 */
export function RequestIncreaseDrawer(props: RequestIncreaseDrawerProps) {
  const { modalState, title, children } = props;
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <BottomSheet maxHeightPercent={92} modalState={modalState}>
        <DialogHeader title={title} onClose={modalState.closeModal} />
        <Box
          sx={(theme) => ({
            flex: 1,
            overflowY: "auto",
            padding: theme.spacing(5),
          })}
        >
          {children}
        </Box>
      </BottomSheet>
    );
  }

  return (
    <Drawer showCloseButton modalState={modalState} title={title}>
      {children}
    </Drawer>
  );
}
